import clsx, { type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['title', 'hero', 'footnote'] }],
      'leading': [{ leading: ['footnote', 'button', 'button-sm', 'body-sm', 'subtitle', 'body', 'title', 'hero'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
